import { FilterItemBaseInterface } from "../interfaces";

import { DistributionCenterItem } from "./DistributionCenters.types";
import { ProductSpecification } from "./Products.types";

import { CommonListProps } from "@/common/types/ListFromApi.types";

interface ProductFilterItem extends FilterItemBaseInterface {
  specifications?: ProductSpecification;
}

export type InventoryItem = {
  id?: string;
  status: boolean;
  availability?: string;
  serialType?: string;
  serialNumber?: string;
  internalCode?: string;
  notes?: string;
  canceledAtStartag: string;
  product?: IProduct;
  distributionCenter?: DistributionCenterItem;
  selfSales?: boolean;
};

interface IProduct {
  id: string;
  name: string;
  ean: string;
  manageStock: boolean;
  specifications: ProductSpecification;
}

export interface ListOfInventories extends CommonListProps {
  items?: InventoryItem[];
}

export enum InventoryAvailabilityBadgeStatusEnum {
  RESERVED = "#FF9800",
  WITHDRAWN = "#2196F3",
  AVAILABLE = "#4CAF50",
  PENDING = "#f1c232",
  SOLD = "#F44336",
  IN_TRANSIT = "#532cee"
}

export enum InventoryAvailabilityTranslatedEnum {
  RESERVED = "Reservado",
  WITHDRAWN = "Retirado",
  AVAILABLE = "Disponível",
  PENDING = "Pendente",
  SOLD = "Vendido",
  IN_TRANSIT = "Em Transferência"
}

export enum InventoryAvailabilityEnum {
  RESERVED = "RESERVED",
  WITHDRAWN = "WITHDRAWN",
  AVAILABLE = "AVAILABLE",
  PENDING = "PENDING",
  SOLD = "SOLD",
  IN_TRANSIT = "IN_TRANSIT"
}

export enum InventorySerialTypeEnum {
  IMEI = "IMEI",
  ICCID = "ICCID",
  TAG = "TAG",
  OTHERS = "OTHERS"
}

export enum InventorySerialTypeTranslatedEnum {
  IMEI = "IMEI",
  ICCID = "ICCID",
  TAG = "TAG",
  OTHERS = "Outros"
}
